import React, { useContext, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Tooltip } from "@mui/material";
import { ChatInfoContext, useTranslation } from "hhn-commons";
import { IGroupInfo, IUserInfo } from "@home-health-notify/domain";
import { RevokeReferralButton } from "./Members.style";
import { RevokeReferralModal } from "../../../addMember/addUsers/actionButtons/RevokeReferralModal";

type RevokeReferralProps = {
  userInfo: IUserInfo;
  groupInfo: IGroupInfo;
};

export const RevokeReferral = ({
  userInfo,
  groupInfo,
}: RevokeReferralProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });
  const { chat } = useContext(ChatInfoContext);
  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] =
    useState<boolean>(false);

  const openConfirmationDialog = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsConfirmationDialogOpen(true);
  };

  const onCloseConfirmationDialog = () => {
    setIsConfirmationDialogOpen(false);
  };

  return (
    <Box style={{ marginLeft: "auto" }}>
      <Tooltip title={tNs("referral.revokeReferral")} arrow>
        <RevokeReferralButton
          onClick={openConfirmationDialog}
          data-testid="revoke-referral-button"
        >
          <DeleteIcon />
        </RevokeReferralButton>
      </Tooltip>
      <RevokeReferralModal
        userInfo={userInfo}
        groupInfo={groupInfo}
        chat={chat}
        isOpen={isConfirmationDialogOpen}
        onClose={onCloseConfirmationDialog}
      />
    </Box>
  );
};
